/**
 * @file パスポート登録
 *
 */
'use strict';

import Modal from '../../Libs/bootstrap/modal';

/**
 * @classname EditPassport
 * @classdesc パスポート登録
 */
export default class EditPassport {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e, controller) {
		console.log('EditPassport.constructor');
		this._$e = $e;
		this._controller = controller;
		controller._$passportEditModal = new Modal(document.getElementById('passportEditModal'));
		$e.on('click', () => this.onClick());
	};

	/**
	 * クリックのコールバック
	 *
	 * @memberof SetComplete
	 * @return {undefined}
	 */
	onClick() {
		console.log('EditPassport.onClick');
		this._controller.autoDeletePassportInfos();
		this._controller.displayPassportInfo();
		const regist = localStorage.getItem('passport') || null;
		const $drawer = $('#drawer');
		if($drawer.hasClass('open')){
			$drawer.removeClass('open').addClass('close');
			$('#drawer-background').fadeOut();
		}
		console.log(regist);
		if(!regist) {
			this._controller._$passportRegistModal.show();
		}else{
			this._controller._$passportEditModal.show();
			$('.block--page1').show();
			$('.block--page2').hide();
		}
	};
}
